// Libraries
import { VictoryStyleInterface } from 'victory';
// Types
import { LineVariationKeys } from '@organisms/index';
import { RatingKeys } from '@globalTypes/index';
// Utils
import { RatingList } from '@utils/constants';
import { colors } from '@theme/foundations';

/**
 * Represents the line variations for the LineChart component.
 *
 * @function
 * @param {number} strokeWidth - The stroke width for the lines.
 * @param {number} strokeDasharray - The stroke dash.
 * @returns {object} - The line variations object.
 */
export const generateLineVariations = (strokeWidth: number, strokeDasharray: number) => {
  const dashedSuffix = 'Dashed';

  const lineVariations: Partial<Record<LineVariationKeys, VictoryStyleInterface>> = {};

  const addLineVariation = (key: LineVariationKeys, stroke: number | string, dasharray?: number) => {
    lineVariations[key] = {
      data: {
        stroke,
        strokeWidth,
        strokeDasharray: dasharray,
      },
    };
  };

  RatingList.forEach((key) => {
    const colorKey = key.endsWith(dashedSuffix) ? key.slice(0, -dashedSuffix.length) : key;
    const stroke = colors.ratings[colorKey as RatingKeys]
      ? colors.ratings[colorKey as RatingKeys].dark
      : colors.ratings.A.dark;

    if (key.endsWith(dashedSuffix)) {
      addLineVariation(key as LineVariationKeys, `url(#${key})`, strokeDasharray);
    } else {
      addLineVariation(key as LineVariationKeys, stroke);
    }
  });

  RatingList.forEach((from) => {
    RatingList.forEach((to) => {
      if (from !== to) {
        const key = `${from}to${to}`;
        const stroke = `url(#${key})`;
        addLineVariation(key as LineVariationKeys, stroke);
        addLineVariation(`${key}${dashedSuffix}` as LineVariationKeys, stroke, strokeDasharray);
      }
    });

    const stroke = colors.ratings[from as RatingKeys] ? colors.ratings[from as RatingKeys].dark : colors.ratings.A.dark;

    addLineVariation(`${from}${dashedSuffix}` as LineVariationKeys, stroke, strokeDasharray);
  });

  return lineVariations;
};
